var exports = {
  "O": "xcc377c0b--4ac59c--rating",
};

module.exports = exports;
